import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
//import Select from 'react-select'
import CreatableSelect from 'react-select/creatable';

export class ContenedoresSemanalesView extends Component {
    constructor(props) {
        super(props);
        var rawUrl = window.location.toString();
        var vaporSemanalProveedor_Id = rawUrl.split("VaporesSemanales/")[1].split("/")[0];
        this.state = {
            operation: props.operation,
            destinos: [],
            contenedores: [],
            bls: [],
            vaporesSemanalesProveedor: []
        };
        if (props.data) {
            console.log("props.data", props.data)
            props.data.fechaDeCarga = props.data.fechaDeCarga.toString().substring(0, 10)
            this.state.model = props.data
        }
        else {
            this.state.model = { vaporSemanalProveedor_Id: vaporSemanalProveedor_Id, bl_Id: 0, semana_Id: 0 };
        }
        console.log(" this.state.model", this.state.model)
        this.state.modelValidation = {
            vaporSemanalProveedor_Id: this.state.model.vaporSemanalProveedor_Id != 0,
            destino_Id: this.state.model.destino_Id != 0,
            contenedor: this.state.model.contenedor != "",
            //etiquetaEspecial: this.state.model.etiquetaEspecial != "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.contenedorChange = this.contenedorChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
        this.load_vaporesSemanalesProveedor = this.load_vaporesSemanalesProveedor.bind(this);
        this.load_destinos = this.load_destinos.bind(this);
        this.load_contenedores = this.load_contenedores.bind(this);
        this.load_bls = this.load_bls.bind(this);
        this.populateData = this.populateData.bind(this);
    }

    async handleChange(event) {
        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, async () => {

            this.props.setModalBodyState(this.state).then(() => this.validate());
        });

    }
    async contenedorChange(value) {
        console.log("contenedorChange", value)
        var tempModel = this.state.model;
        tempModel["contenedor"] = value.value.toUpperCase();
        this.setState({
            model: tempModel
        }, async () => {

            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
    }

    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/contenedoresSemanales/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }

    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <Row>
                            {this.state.model.semana_Id ? (
                                <FormGroup className="col col-md-6">
                                    <Label for="vaporSemanalProveedor_Id">
                                        <FormattedMessage id='Vapor' />
                                    </Label>

                                    <Input
                                        id="vaporSemanalProveedor_Id"
                                        name="vaporSemanalProveedor_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        value={this.state.model.vaporSemanalProveedor_Id}
                                    >
                                        <option value="0"></option>
                                        {this.state.vaporesSemanalesProveedor.map(item => (
                                            <option
                                                key={item.vaporSemanalProveedor_Id}
                                                value={item.vaporSemanalProveedor_Id}
                                            >
                                                {item.barcoViaje}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            ) : null}
                            <FormGroup className="col col-md-6">
                                <Label for="fechaDeCarga">
                                    <FormattedMessage id='FechaDeCarga' />
                                </Label>
                                <Input
                                    id="fechaDeCarga"
                                    name="fechaDeCarga"
                                    //placeholder={placeholder}
                                    type="date"
                                    onChange={this.handleChange}
                                    value={this.state.model.fechaDeCarga}
                                    valid={this.getValidationValue(this.state.modelValidation.fechaDeCarga)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.fechaDeCarga)}
                                />
                                <FormFeedback>
                                    {this.state.model.fechaDeCarga == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                </FormFeedback>
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup className="col col-md-6">
                                <Label for="destino_Id">
                                    <FormattedMessage id='Destino' />
                                </Label>
                                <Input
                                    id="destino_Id"
                                    name="destino_Id"
                                    type="select"
                                    onChange={this.handleChange}
                                    value={this.state.model.destino_Id}
                                    valid={this.getValidationValue(this.state.modelValidation.destino_Id)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.destino_Id)}
                                >
                                    <option value="0"></option>
                                    {this.state.destinos.map(destino => destino.destino_Id == this.state.model.destino_Id ? (
                                        <option value={destino.destino_Id} selected>
                                            {destino.nombre}
                                        </option>
                                    ) : (<option value={destino.destino_Id}>{destino.nombre}</option>))}
                                </Input>
                                <FormFeedback>
                                    {this.state.model.destino_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                </FormFeedback>
                            </FormGroup>
                            <FormGroup className="col col-md-6">
                                <Label for="contenedor">
                                    <FormattedMessage id='Contenedor' />
                                </Label>
                                {/*<CreatableSelect*/}
                                {/*    defaultValue={({ value: this.state.model.contenedor, label: this.state.model.contenedor })}*/}
                                {/*    onChange={this.contenedorChange}*/}
                                {/*    onInputChange={(newValue) => { return newValue.toUpperCase() } }*/}
                                {/*    options={this.state.contenedores.map(x => ({ value: x.nombre, label: x.nombre }))}*/}
                                {/*    required={true}*/}
                                {/*    formatCreateLabel={(inputValue) => `Crear contenedor: ${inputValue}`}*/}
                                {/*/>*/}
                                <Input
                                    id="contenedor"
                                    name="contenedor"
                                    type="text"
                                    onChange={this.handleChange}
                                    value={this.state.model.contenedor}
                                    valid={this.getValidationValue(this.state.modelValidation.contenedor)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.contenedor)}
                                />
                                <FormFeedback>
                                    {this.state.model.contenedor == "" ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                </FormFeedback>
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup className="col col-md-12">
                                <Label for="bl">
                                    <FormattedMessage id='BL' />
                                </Label>
                                <Input
                                    id="bL_Id"
                                    name="bL_Id"
                                    type="select"
                                    onChange={this.handleChange}
                                    value={this.state.model.bL_Id}
                                >
                                    <option value="0"></option>
                                    {this.state.bls.map(bl => bl.bL_Id == this.state.model.bL_Id ? (
                                        <option value={bl.bL_Id} selected>
                                            {bl.nombre}
                                        </option>
                                    ) : (<option value={bl.bL_Id}>{bl.nombre}</option>))}
                                </Input>
                            </FormGroup>

                        </Row>
                        <Row>
                            <FormGroup className="col col-md-6">
                                <Label for="pesoTara">
                                    <FormattedMessage id='PesoTara' />
                                </Label>
                                <Input
                                    id="pesoTara"
                                    name="pesoTara"
                                    type="number"
                                    min="3000"
                                    max="6000"
                                    onChange={this.handleChange}
                                    value={this.state.model.pesoTara}
                                    valid={this.getValidationValue(this.state.modelValidation.pesoTara)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.pesoTara)}
                                />
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup className="col col-md-12">
                                <Label for="etiquetaEspecial">
                                    <FormattedMessage id='EtiquetaEspecial' />
                                </Label>
                                <Input
                                    id="etiquetaEspecial"
                                    name="etiquetaEspecial"
                                    type="text"
                                    onChange={this.handleChange}
                                    value={this.state.model.etiquetaEspecial}
                                />
                                {/*<FormFeedback>*/}
                                {/*    {this.state.model.etiquetaEspecial == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}*/}
                                {/*</FormFeedback>*/}
                            </FormGroup>
                        </Row>




                    </Form>
                </Row>
            </div>
        );
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {
        this.setState({
            loading: true,
            destinos: await this.load_destinos(), contenedores: await this.load_contenedores(), bls: await this.load_bls(),
            vaporesSemanalesProveedor: await this.load_vaporesSemanalesProveedor()
        },

        );
    }
    async load_vaporesSemanalesProveedor() {
        const semanaId = this.state.model.semana_Id;
        if (!semanaId) {
            return [];
        }

        // Otherwise, fetch from API
        const token = await authService.getAccessToken();
        const response = await fetch('api/vaporesSemanalesProveedor?semana_Id=' + semanaId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        return await response.json();
    }
    async load_destinos() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/destinos/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_contenedores() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/contenedores?destino_Id=' + this.state.model.destino_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_bls() {
        var rawUrl = window.location.toString();
        var vaporSemanalProveedor_Id = rawUrl.split("VaporesSemanales/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/bls?vaporSemanalProveedor_Id=' + this.state.model.vaporSemanalProveedor_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
}